import contactImage from "../images/contactImage.png";

const Contact = () => {
  return (
    <div className="h-fit py-5 max-w-[1400px] mx-auto  flex justify-between flex-wrap ">
      <div className="max-w-[400px] mx-auto">
        <img
          className="w-full -translate-x-1/2 -translate-y-1/2 animate-float "
          src={contactImage}
          alt="Contact"
        />
      </div>
      <div className=" mt-5 w-auto md:w-[500px] p-4">
        <h1 className="text-3xl  md:text-5xl font-semibold">Message</h1>
        <form className="mt-5">
          <div className="flex flex-col md:flex-row ">
            <input
              className="bg-transparent w-full md:w-[50%] border mx-1 p-4 rounded-3xl border-yellow-400"
              type="text"
              placeholder="First Name"
            />
            <input
              className="bg-transparent w-full mt-4 md:mt-0 md:w-[50%] border p-4 mx-1 rounded-3xl border-yellow-400"
              type="text"
              placeholder="Last Name"
            />
          </div>
            <input
              className="bg-transparent mt-4 w-full border p-4 mx-1 rounded-3xl border-yellow-400"
              type="email"
              placeholder="E-mail"
            />
            <textarea
              className="bg-transparent mt-4 w-full border p-4 mx-1 rounded-3xl border-yellow-400"
              type="email"
              rows={4}
              placeholder="Message"
            />
            <button className="mt-5 p-3 rounded-3xl hover:bg-gradient-to-l text-gray-800 bg-gradient-to-r from-yellow-400 to-yellow-500 w-full">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;